import { memberApi } from "./client";

export interface ReadingReference {
  title: string; file_url: string | null; file_size: number | null; material_type: string | null;
  google_drive_file_id?: string | null; google_drive_resource_key?: string | null; google_drive_mime_type?: string | null;
}
export interface ReadingContent extends ReadingReference { topic_id: string | null; due_at: string | null; optional: boolean }
export interface ReadingSnapshot {
  revision: number; topic_id: string | null; content: ReadingReference; due_at: string | null; optional: boolean;
  material_id?: string; published_at?: string; saved_at?: string;
}
export interface CourseReading extends ReadingSnapshot { id: string; sort_order: number; published?: ReadingSnapshot | null }
export interface CourseReadings {
  course_id: string; course_status: string; timezone: string; read_at: string; can_edit: boolean; can_publish: boolean; readings: CourseReading[];
}
export interface ReadingReceipt { state: "confirmed"; reading_id: string; revision?: number; published_revision?: number; waiting_for_course?: boolean }
const route = (course: string) => `/courses/${course}/readings`;
const keyed = (key: string) => ({ headers: { "Idempotency-Key": key } });
export const courseReadingsApi = {
  read: (course: string, preparation = false) => memberApi.get<CourseReadings>(`${route(course)}${preparation ? "/preparation" : ""}`),
  create: (course: string, body: ReadingContent & { id: string }, key: string) => memberApi.post<ReadingReceipt>(route(course), body, keyed(key)),
  save: (course: string, reading: string, body: ReadingContent & { revision: number }, key: string) => memberApi.put<ReadingReceipt>(`${route(course)}/${reading}`, body, keyed(key)),
  publish: (course: string, reading: string, body: { revision: number; published_revision: number | null }, key: string) => memberApi.post<ReadingReceipt>(`${route(course)}/${reading}/publish`, body, keyed(key)),
};
